import { render } from "./PerfilMainView.vue?vue&type=template&id=6ac1fe62&scoped=true&ts=true"
import script from "./PerfilMainView.vue?vue&type=script&lang=ts"
export * from "./PerfilMainView.vue?vue&type=script&lang=ts"

import "./PerfilMainView.vue?vue&type=style&index=0&id=6ac1fe62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac1fe62"]])

export default __exports__